class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.content = summary ? summary.nextElementSibling : null;

    // Store bound handlers so disconnectedCallback can remove them.
    this._boundFocusOut = this.onFocusOut.bind(this);
    this._boundToggle = this.onToggle.bind(this);
    this.mainDetailsToggle.addEventListener('focusout', this._boundFocusOut);
    this.mainDetailsToggle.addEventListener('toggle', this._boundToggle);
  }

  disconnectedCallback() {
    if (this.mainDetailsToggle && this._boundFocusOut) {
      this.mainDetailsToggle.removeEventListener('focusout', this._boundFocusOut);
      this.mainDetailsToggle.removeEventListener('toggle', this._boundToggle);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    if (this.content) {
      if (!this.animations) this.animations = this.content.getAnimations();

      if (isOpen) {
        this.animations.forEach((animation) => animation.play());
      } else {
        this.animations.forEach((animation) => animation.cancel());
      }
    }
    // Keep aria-expanded synced on both open and close (was only set on close before).
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    this.syncHeaderAutoHideLock();
  }

  syncHeaderAutoHideLock() {
    if (!this.mainDetailsToggle.closest('.header__inline-menu')) return;

    const stickyHeader = this.closest('sticky-header');
    if (!stickyHeader) return;

    const hasOpenDesktopMenu = !!stickyHeader.querySelector('.header__inline-menu details[open]');
    stickyHeader.preventHide = hasOpenDesktopMenu;
    if (hasOpenDesktopMenu && typeof stickyHeader.reveal === 'function') stickyHeader.reveal();
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.get('details-disclosure') || customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.get('header-menu') || customElements.define('header-menu', HeaderMenu);
